import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faEye } from '@fortawesome/pro-light-svg-icons/faEye';
import { faLink } from '@fortawesome/pro-light-svg-icons/faLink';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { DataHubService } from 'src/core/services/datahub';
import { ViewPageAsSchema } from 'src/core/services/datahub/schemas/modules/viewPageAs';
import { useGetContentUrl } from 'src/modules/contents/hooks/useGetContentUrl';
import { Button } from 'src/shared/components/button';
import { Icon } from 'src/shared/components/icon';
import { Toast } from 'src/shared/components/toast';
export function ActionButtons() {
    const { t } = useTranslation();
    const { pageId } = useParams();
    const contentUrl = useGetContentUrl({ pageId: pageId, pageType: 'content' });
    function handleCopy() {
        navigator.clipboard.writeText(contentUrl).then(() => {
            Toast.show({
                type: 'success',
                message: t('content.toast.edit.link_copied')
            });
        });
    }
    function handleViewAs() {
        DataHubService.sendEvent({
            schema: new ViewPageAsSchema({
                arrivedFrom: window.location.href
            })
        });
    }
    return (_jsxs("div", { className: "ml-2 hidden gap-2 md:flex", children: [_jsx(Button, { onClick: handleCopy, variation: "secondary", "aria-label": t('content.copy_content_link'), children: _jsx(Icon, { icon: faLink, size: "lg", className: "my-[0.075rem]" }) }), _jsxs(Button, { href: contentUrl, onClick: handleViewAs, target: "_blank", variation: "secondary", children: [_jsx(Icon, { icon: faEye, size: "lg" }), " ", t('general.view')] })] }));
}
